import React , {useEffect, useState} from 'react'; 
import '../assets/css/custom.css'; 
import '../assets/css/client.css'; 
import '../assets/css/font-awesome.css';
import '../assets/css/sweetalert.css';
import '../assets/css/bootstrap.min.css';
import bike from '../assets/img/bike.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faEdit, faPlus, faSort, faTrash, faEllipsisVertical, faTrashCan, faPenToSquare} from '@fortawesome/free-solid-svg-icons';
import clientlogo from '../assets/img/user1.jpg'; 
import NoBuilding from "../assets/img/no-society-icon.png";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Menus from "./menus";
import stopMark from "../assets/img/stop.png";
import TowerIcon from "../assets/img/society-tile-icon.png";
import {commonAPI} from "../services/CommonAPIService"
import {ErrorSource} from '../common/constants'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// ────────────────────────────────────────────────
//          ROLE ICON IMPORTS (as you provided)
// ────────────────────────────────────────────────
import ACREPR from "../assets/img/Society Roles/ACREPR (1).png";
import APREPR from "../assets/img/Society Roles/APREPR (1).png";
import BARBER from "../assets/img/Society Roles/BARBER (1).png";
import BBALL from "../assets/img/Society Roles/BBALL (1).png";
import BEAUTY from "../assets/img/Society Roles/BEAUTY (2).png";
import CARCLN from "../assets/img/Society Roles/CARCLN (1).png";
import COOK from "../assets/img/Society Roles/COOK.png";
import DANCE from "../assets/img/Society Roles/DANCE (2).png";
import DRIVER from "../assets/img/Society Roles/DRIVER.png";
import ELCARE from "../assets/img/Society Roles/ELCARE (1).png";
import FBALL from "../assets/img/Society Roles/FBALL (1).png";
import FLOWER from "../assets/img/Society Roles/FLOWER (2).png";
import GENMCH from "../assets/img/Society Roles/GENMCH.png";
import GROCER from "../assets/img/Society Roles/GROCER (1).png";
import LAUNDR from "../assets/img/Society Roles/LAUNDR (2).png";
import MAID from "../assets/img/Society Roles/MAID (4).png";
import MILKMN from "../assets/img/Society Roles/MILKMN.png";
import MUSIC from "../assets/img/Society Roles/MUSIC (2).png";
import NANNY from "../assets/img/Society Roles/NANNY (2).png";
import NURSE from "../assets/img/Society Roles/NURSE (3).png";
import PAINT from "../assets/img/Society Roles/PAINT (2).png";
import PAPBOY from "../assets/img/Society Roles/PAPBOY.png";
import PHYSIO from "../assets/img/Society Roles/PHYSIO (3).png";
import SECGUD from "../assets/img/Society Roles/SECGUD.png";
import SECSUP from "../assets/img/Society Roles/SECSUP.png";
import SWEET from "../assets/img/Society Roles/SWEET.png";
import TAILOR from "../assets/img/Society Roles/TAILOR (1).png";
import TUTION from "../assets/img/Society Roles/TUTION (1).png";
import VEGETABLE from "../assets/img/Society Roles/VEGETABLE (3).png";
import WTCLNR from "../assets/img/Society Roles/WTCLNR (1).png";
import YOGA from "../assets/img/Society Roles/YOGA (1).png";
import OTHER from "../assets/img/Society Roles/OTHER.png";

// Role icons mapping
const roleIcons = {
  ACREPR, APREPR, BARBER, BBALL, BEAUTY, CARCLN, COOK, DANCE, DRIVER,
  ELCARE, FBALL, FLOWER, GENMCH, GROCER, LAUNDR, MAID, MILKMN, MUSIC,
  NANNY, NURSE, PAINT, PAPBOY, PHYSIO, SECGUD, SECSUP, SWEET, TAILOR,
  TUTION, VEGETABLE, WTCLNR, YOGA,
  OTHER: OTHER,
  default: OTHER,
};

function SocietyRole()  { 
    const [TowerList, setTowerList] = useState([]);
    const [TowerId, setTowerId] = useState("");
    const [BuildingList, setBuildingList] = useState("");
    const [BuildingId, setBuildingId] = useState("");
    const [TowerName, setTowerName] = useState("");
    const [BuildingName, setBuildingName] = useState("");
    const [Loading, setLoading] = useState(false);
    const [UserData, setUserData] = useState("");
    const [AddTowerBtn, setAddTowerBtn] = useState(false);
    const [UpdateTowerBtn, setUpdateTowerBtn] = useState(false);
    const [oldVehicleIndex,setOldVehicleIndex] = useState(null)
    const [vehicleMenu,showVehicleMenu] = useState(null)
    const [DeleteShow, setDeleteShow] = useState(false);
    const [SelectedtowerId,setSelectedTowerId] = useState("")
    const [CategoryList,setCategoryList] = useState("")
    const [CategoryIdSelected,setCategoryIdSelected] = useState("")
    const [IsEditable,setIsEditable] = useState(false)
    // const [SocietyId,setSocietyId] = useState("")
    console.log("BuildingId", BuildingId)

    const setInputValue = (item) => {
        setShow(true)
        console.log("item", item)
        setAddTowerBtn(false)
        setUpdateTowerBtn(true)
        setTowerName(item?.roleName)
        setTowerId(item?.roleId)
    };

    const openCreateModal = () => {
        if(CategoryIdSelected){
            setShow(true)
            setAddTowerBtn(true)
            setUpdateTowerBtn(false)
            setBuildingName(BuildingId)
            // setCategoryIdSelected("")
            setTowerName("")
        }else{
            toast.warning("Please select Department");
        }
    };


    const GetCategoryList = async () => {

        try {
            // let myBuildingId;
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            setUserData(myUserData);
            setLoading(true);
            const endPointVariableKey = {
                // urlVariable: CategoryIdSelected,
                buildingId:myUserData?.buildingId
            }

            let response = await commonAPI("Department", undefined, endPointVariableKey);
            if (response?.success===true){
                console.log("Table Department", response)
                setCategoryList(response?.data);
                setLoading(false);
            }else{
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": null,
                "uri": "Department",
                "errorNumber": "DL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "SocietyRole.js",
                "functionName": "GetDepartmentList",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    const GetTowerList = async () => {

        try {
            // let myBuildingId;
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            setUserData(myUserData);
            setLoading(true);
            const endPointVariableKey = {
                urlVariable: CategoryIdSelected,
                buildingId:myUserData?.buildingId
            }

            let response = await commonAPI("SocietyRole", undefined, endPointVariableKey);
            if (response?.success===true){
                console.log("Table SocietyRole", response)
                setTowerList(response?.data[0].roles);
                setLoading(false);
            }else{
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": null,
                "uri": "SocietyRole",
                "errorNumber": "SL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "SocietyRole.js",
                "functionName": "GetSocietyList",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }
    useEffect(() => {
        GetCategoryList();
    }, [])
    useEffect(() => {
        if(CategoryIdSelected){
            GetTowerList();
        }else{
            setTowerList("")
        }
    }, [CategoryIdSelected])

    useEffect(() => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        if(myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Support Admin" ) {
            setIsEditable(false);
        }else{
            setIsEditable(true);
        }
    }, [])


    const ShowDeleteModal = (item) => {
        setDeleteShow(true);
        setSelectedTowerId(item)

    }

    const DeleteTower = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodydata = { 
            "roleId": SelectedtowerId?.roleId,
            "modifiedUserId": JSON.stringify(myUserData?.userId),
          };
        try {
            setLoading(true);
            const endPointVariableKey = {
                buildingId: myUserData?.buildingId
            }

            let response = await commonAPI("SocietyRoleDelete", bodydata, endPointVariableKey);
            
              if(response?.success == true && response?.message?.length == 0){
                toast.success("Society Role Deleted"); 
                setLoading(false); 
                GetTowerList();
                setDeleteShow(false);
              }else{
                toast.error(response.message[0]);
                setLoading(false);
              }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "SocietyRoleDelete",
                "errorNumber": "TD01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "SocietyRole.js",
                "functionName": "DeleteSocietyRole",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
          
    }

     

    const addNewTower = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodydata = {
            departmentId: CategoryIdSelected,
            roleName: TowerName,
            isEditable: IsEditable,
            createdUserId: JSON.stringify(myUserData?.userId),
        }
        try {
            setLoading(true);
            if(!CategoryIdSelected){
                toast.warning("Please select Department");
                setLoading(false)
            }else if(!TowerName){
                toast.warning("Please enter Society Role Name");
                setLoading(false)
            }else{
                const endPointVariableKey = {
                    buildingId:myUserData?.buildingId
                }
                let response = await commonAPI("SocietyRoleAdd", bodydata, endPointVariableKey);
                if(response?.success == true && response?.message?.length == 0){
                    toast.success("Society Role Added"); 
                    // console.log(response.success);
                    GetTowerList();
                    setShow(false)
                    setLoading(false);
                }else{
                    toast.error(response?.message[0]);
                    setLoading(false);
                }
            }    

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "SocietyRoleAdd",
                "errorNumber": "ASR01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "SocietyRole.js",
                "functionName": "addNewSocietyRole",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
      };


    const UpdateTower = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            departmentId: CategoryIdSelected,
            roleName: TowerName,
            roleId: TowerId,
            modifiedUserId: JSON?.stringify(myUserData?.userId),
        }
        try {
            setLoading(true);
            
            if(!CategoryIdSelected){
                toast.warning("Please select Department");
                setLoading(false)
            }else if(!TowerName){
                toast.warning("Please enter Society Role Name");
                setLoading(false)
            }else{
                const endPointVariableKey = {
                    buildingId: myUserData?.buildingId
                }
                let response = await commonAPI("SocietyRoleUpdate", bodyData, endPointVariableKey);
                
                if(response?.success == true && response?.message?.length == 0){
                    toast.success("Society Role Updated"); 
                    // console.log(response.success);
                    GetTowerList();
                    setShow(false)
                    setLoading(false);
                }else{
                    toast.error(response?.message[0]);
                    setLoading(false);
                }
            }    

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "SocietyRoleUpdate",
                "errorNumber": "AT01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "SocietyRole.js",
                "functionName": "UpdateSocietyRole",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };  

    function setVehicleIndex(index) {
        console.log(oldVehicleIndex == index, "oldVehicleIndex==index")
        if (oldVehicleIndex == index) {
            setOldVehicleIndex(null)
            showVehicleMenu(null)

        }
        else {
            showVehicleMenu(index)
            setOldVehicleIndex(index)

        }
        // setHideVehicleMenu(true)
    }  
      

    const [show, setShow] = useState(false);

     return (
    <>
    {Loading? 
        <div className="loaderDiv">
          <div className="loader"></div>
        </div> 
      :null}
      {/* <Menus/> */}
 
      <ToastContainer />
      <div className="row mb-3 mt-5 pt-2" style={{alignItem:'center'}}>
            <div className="col-lg-6 col-md-6">
                <div className="HeadingTop">
                    <h3> Society Role </h3>
                    <span> Define roles and responsibilities for various society members.</span>
                </div>
            </div>
            <div className="col-lg-6 col-md-6 mb-3 mb-md-0  text-right" style={{alignContent:'center'}}>
                <select size="md" className="sltareamodal col-4 ml-auto" value={CategoryIdSelected} onChange={(e) => {
                    console.log("selection", e.target.value)
                    setCategoryIdSelected(e.target.value);}}>
                    <option value="">Select Department</option>
                    {CategoryList ? CategoryList?.map((item, index) =>  <option key={index} value={item?.departmentId}>{item?.departmentName}</option>): null}
                </select>
                <Button variant="btn btn-info" onClick={() => openCreateModal()}>+ Create New </Button>{' '}
            </div>
        </div>
      
             






            <Modal size="md" show={show} onHide={() =>  setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
                        <Modal.Header closeButton className='headerMDL'>
                            <Modal.Title id="contained-modal-title-vcenter" onClick={openCreateModal}>
                                {UpdateTowerBtn ?   <>Update Society Role</> : <>Add  Society Role</> }
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="helpingElelemnt_uuy002">

          
                      <div className="row" id="validation">
                    <div className="col-12">
                       
                            <div className="card-body p-0">
                         
                                <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" novalidate="novalidate">
                                    
                                        <div className="content clearfix">
                                     
                                    
                                    <section id="steps-uid-2-p-0" role="tabpanel" aria-labelledby="steps-uid-2-h-0" className="body current pt-2" aria-hidden="false">
                                        <div className="row text-left">
                                            <div className="form-group">
                                                <label >Department <span className="danger">*</span></label>
                                                <select name="taskTypes" style={{height: 30}} className="form-control" value={CategoryIdSelected} onChange={(e) => {setCategoryIdSelected(e.target.value);}}>
                                                    <option value="" disabled>Select Department</option>
                                                    {CategoryList ? CategoryList?.map((item, index) =>  <option key={index} value={item?.departmentId}>{item?.departmentName}</option>): null}
                                                </select>
                                            </div>
                                            <div className="col-md-12 mb-2 mt-2">
                                                <div className="form-group">
                                                    <label for="wfirstName2"> Society Role Name  <span className="danger">*</span> </label>
                                                    <input type="text" value={TowerName} onChange={(e)=>{setTowerName(e.target.value)}}  className="form-control required" id="wfirstName2" name="firstName" aria-required="true" /> </div>
                                            </div>
                                            {UserData?.roleName == "Super Admin" || UserData?.roleName == "Support Admin" ? 
                                            <>
                                             {AddTowerBtn ?
                                                <div className="col-md-12">
                                                    <div className="form-group text-left mt-2">
                                                        <label for="fav_language"> Is Editable </label><br />
                                                        <input type="radio" id="yes" name="fav_language" value="true" checked={IsEditable === true} onChange={() => setIsEditable(true)} />
                                                        <label for="yes">Yes</label><br />
                                                        <input type="radio" id="No" name="fav_language" value="false" checked={IsEditable === false} onChange={() => setIsEditable(false)} />
                                                        <label for="No">No</label><br />
                                                    </div>
                                                </div>
                                              :null}  
                                            </>
                                            :null}
                                            

                                        </div>  
                                    </section>
 
                                </div>
                                

                                    </form>
                            </div>
                         
                    </div>
                </div>
            
        </Modal.Body>

        <div className="fixed_allbtn">                        
              <div className="upload_btn">
              <ul role="menu" aria-label="Pagination" className='mb-0'>
                                        {AddTowerBtn ?
                                            // <li aria-hidden="false" aria-disabled="false">
                                            //     <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                            //     <a className='btn btn-contained' onClick={addNewTower} role="menuitem">Submit </a>
                                            // </li>
                                            <div className="  align-self-start">
                                                <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                                <button type="button" className="btn btn-info" onClick={() => addNewTower()}> Submit</button>
                                            </div>
                                        :null} 
                                        {UpdateTowerBtn ?
                                            <div className="  align-self-start">
                                                <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                                <button type="button" className="btn btn-info" onClick={() => UpdateTower()}> Update</button>
                                            </div>
                                            // <li aria-hidden="true">
                                            //     <a href="#finish" onClick={UpdateTower} role="menuitem">Update</a>
                                            // </li>
                                        :null}    
                                    </ul>
                                          </div>
 </div>


      
      </Modal>




  
          <div className="row">
                    <div className="col-12">
    
                                 
                                    <div id="example23_wrapper" className="dataTables_wrapper pt-0">                                        
                                    <div className="row">

                                    {!CategoryIdSelected || !TowerList?.length &&  TowerList?.length != null ?
                                    <div className='bg-white' style={{paddingBottom:"50px",borderRadius: "10px"}}>
                                        <div className='col-12 text-center'>
                                            <img src={NoBuilding} alt="user" class="mx-auto mt-5" style={{height: "100px"}} />
                                        </div>    
                                        <br />
                                        <h3 className='col-12 text-center  NoDataShowTextColor' style={{marginTop: "0px"}}> No Society Role found</h3>
                                        <h5 className='col-12 text-center  NoDataShowTextColor' style={{marginTop: "10px"}}> Click on Create New button to add a Society Role</h5>
                                    </div> : null}
                                    {TowerList
                                        ? TowerList?.map((item, index) => (
                                        <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
                                            <div className="clientTiles" style={{height:115}}>
                                                <div className="ClientImg">
                                                    <div className="tabs_img">
                                                      {item?.imageIconURL ? (
                                                        <img 
                                                          src={item?.imageIconURL} 
                                                          className="img img-responsive" 
                                                          alt="client-img"
                                                          onError={(e) => { e.target.src = roleIcons.OTHER; }}
                                                        />
                                                      ) : (
                                                        <img 
                                                          src={roleIcons[item?.shortCode || item?.iconCode || item?.roleCode || "OTHER"] || roleIcons.OTHER} 
                                                          className="img img-responsive" 
                                                          alt="client-img" 
                                                        />
                                                      )}
                                                    </div>
                                                    <div class="bars_font">
                                                        {UserData?.roleName == "Super Admin" || UserData?.roleName == "Support Admin" ?
                                                            <>
                                                                {item?.isEditable ? 
                                                                <>
                                                                    <h3 className="font_trigger" onClick={() => {setInputValue(item);}} >
                                                                        <FontAwesomeIcon icon={faPenToSquare} />
                                                                    </h3>
                                                                    <h3 className="font_trigger" onClick={() => {ShowDeleteModal(item);}}>
                                                                        <FontAwesomeIcon icon={faTrashCan} />
                                                                    </h3>
                                                                </>
                                                                :null}
                                                            </>    
                                                            :null
                                                        }
                                                        {UserData?.roleName != "Super Admin" && UserData?.roleName != "Support Admin" ?
                                                            <>  
                                                                {item?.isEditable     ?
                                                                    <h3 className="font_trigger" onClick={() => {setInputValue(item);}} >
                                                                        <FontAwesomeIcon icon={faPenToSquare} />
                                                                    </h3>
                                                                    : 
                                                                    <h3 className="font_trigger" onClick={() => {toast.warning("This society role cannot be edited.")}} >
                                                                        <FontAwesomeIcon icon={faPenToSquare} />
                                                                    </h3>
                                                                }
                                                                {item?.isEditable ?
                                                                    <h3 className="font_trigger" onClick={() => {ShowDeleteModal(item);}}>
                                                                        <FontAwesomeIcon icon={faTrashCan} />
                                                                    </h3>
                                                                    :       
                                                                    <h3 className="font_trigger" onClick={() => {toast.warning("This society role cannot be Deleted.")}}>    
                                                                        <FontAwesomeIcon icon={faTrashCan} />
                                                                    </h3>
                                                                }    
                                                            </>
                                                            :null
                                                        }
                                                    </div>
                                                </div>
                                                <div className="ClientText">
                                                    <div className="l-two">
                                                        <h1> {item?.roleName} </h1>
                                                        {/* <h4>{item?.buildingName} </h4> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        ))
                                        : null}
                                    </div>
                                </div>
                         
          
            </div>
        </div>
        
        <Modal centered show={DeleteShow} onHide={() =>
            setDeleteShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
            <Modal.Body className='p-0' style={{borderRadius: "10px", overflow: "hidden"}}>
                <div className="row px-3" id="validation">
                    <div className="col-12 bg-white pt-3 pb-2">
                        <div className="FnFItem" style={{justifyContent: "flex-start"}}>
                            <div className="FnFtxt">
                                <h2> Delete Society Role  </h2>
                                <h3> Are you sure you want to delete? </h3>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
                <div className='confirmation_btn pb-4 pt-3 px-3' style={{justifyContent: "center", borderTop: "1px solid #dadada"}}>
                        <div className='both_ConfrmBTN col-6' onClick={DeleteTower}>
                            <Button variant="danger">Delete</Button>{' '}
                        </div>
                        <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
                            <Button variant="light"> Cancel</Button>{' '}
                        </div>
                    </div>
            </Modal.Body>
        </Modal>

        </>)

}
export default SocietyRole